import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ServicesHelper } from '../helpers/index';
import { RestrictionResult, RestrictionValidate } from '../models/index';
import { CheckEntity } from '../models/check-entity';

@Injectable()
export class RestrictionService extends BaseService<any> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string) {
    const url: string = apiUrl + 'restriction/';
    super(apiUrl, url, httpClient);
  }

  public validate(restriction: RestrictionValidate): Observable<RestrictionResult> {
    const response: Observable<RestrictionResult> = this.httpClient.post<RestrictionResult>(`${this.url}`, restriction);
    return response;
  }

  public amount() {
    const response = this.httpClient.get<number>(`${this.url}amount`);
    return response;
  }

  public clientWarning(clientIds: Array<CheckEntity>): Observable<any> {
    const response: Observable<any> = this.httpClient.post<any>(`${this.url}warning`, clientIds);
    return response;
  }
}
